import type { Lci3DimensionTableData } from '@features/lci-report/models/lci3-types';
import { isTopBottomName } from '@features/lci-report/slides/overview-slide-interface-v2';
import type { Subdimension } from '@features/reports/subdomains/visitation';
import {
  validDimensionSlug,
  convertSlugToDimensionName,
} from '@features/reports';

export type FlattenedSubdimension = Subdimension & {
  dimensionName: string;
};

export type DimensionGroup = {
  slug: string;
  dimensionName: string;
  subdimensions: Subdimension[];
};

export const flattenDimensionData = (
  dimensionTableData: Lci3DimensionTableData
): FlattenedSubdimension[] =>
  Object.entries(dimensionTableData)
    .filter(([slug]) => !isTopBottomName(slug))
    .flatMap(([slug, subdimensions]) => {
      const dimensionName = validDimensionSlug(slug)
        ? convertSlugToDimensionName(slug)
        : slug;

      return subdimensions.map(subdimension => ({
        ...subdimension,
        dimensionName,
      }));
    });

export const groupDimensionData = (
  dimensionTableData: Lci3DimensionTableData
): DimensionGroup[] =>
  Object.entries(dimensionTableData)
    .filter(([slug]) => !isTopBottomName(slug))
    .map(([slug, subdimensions]) => ({
      slug,
      dimensionName: validDimensionSlug(slug)
        ? convertSlugToDimensionName(slug)
        : slug,
      subdimensions,
    }));
